import * as React from 'react';
import { NavLink } from 'react-router-dom';
import useClickOutside from '../../Hooks/useClickOutside';
import { dicoverTopCollections, dicoverTopSallerInDayData, discoverFeaturedCollections, disoverCatagoriesData } from '../../Shared/DiscoverPageFakeData';
import './Discover.scss';
import { HotAndExpoloreSection } from './HotAndExpoloreSection/HotAndExpoloreSection';
import { Swiper, SwiperSlide } from 'swiper/react';
import { AnimatePresence, motion } from "framer-motion"


import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper";
import { useState } from 'react';
import { PostGrid } from '../../Components/PostGrid/PostGrid';
import { PreviewCarousel } from '../../Components/PreviewCarousel/PreviewCarousel';
import { DiscoverLiveAuctions } from './DiscoverLiveAuctions/DiscoverLiveAuctions';
import { DiscoverBuyNFTs } from './DiscoverBuyNFTs/DiscoverBuyNFTs';
import { DiscoverMintNFTs } from './DiscoverMintNFTs/DiscoverMintNFTs';
import { DiscoverExploreSection } from './HotAndExpoloreSection/DiscoverExploreSection/DiscoverExploreSection';

export interface IAppProps {

}

export function Discover(props: IAppProps) {
    const [featuredCollectionData, setFeaturedCollectionData] = useState(discoverFeaturedCollections)

    // for the top section categories functionalities-----------------
    const [selectedCategories, setSelectedCategories] = useState([])
    const handleCategorySelecte = (id: number, cateName: string) => {
        const prevSelectedCate: any = [...selectedCategories]
        if (prevSelectedCate.indexOf(cateName) < 0) {
            prevSelectedCate.push(cateName)
            setSelectedCategories(prevSelectedCate);
        }
        else {
            return
        }
    }
    const hanldeCategoryDelete = (CateName: any) => {
        const prevSelectedCate: any = [...selectedCategories]
        const withoutClosedCate = prevSelectedCate.filter((cate: string) => cate !== CateName)
        setSelectedCategories(withoutClosedCate);
    }



    // top collection in dropdown
    const [topColleInDropOpen, setTopColleInDropOpen] = React.useState(false)
    const [topColleInDropText, setTopColleInDropOpenText] = React.useState('1 Day');
    let topColleInDropRef = React.useRef<HTMLHeadingElement>(null)
    useClickOutside(topColleInDropRef, () => setTopColleInDropOpen(false))

    // top Seller dropdown
    const [topSellerDropOpen, setTopSellerDropOpen] = React.useState(false)
    const [topSellerDropText, settopSellerDropText] = React.useState('Seller');
    let topSellerDropRef = React.useRef<HTMLHeadingElement>(null)
    useClickOutside(topSellerDropRef, () => setTopSellerDropOpen(false))


    // for second Day Dropdown
    const [topInDropOpen, setTopInDropOpen] = React.useState(false)
    const [topInDropText, setTopInDropText] = React.useState('1 Day');
    let topInDropRef = React.useRef<HTMLHeadingElement>(null)
    useClickOutside(topInDropRef, () => setTopInDropOpen(false))









    //----------------------- Featured Collections -----------------------
    const [windowWidth, setWindowWidth] = useState(1920)
    React.useEffect(() => {
        setWindowWidth(window.outerWidth);
    }, [])


    const [carouselDataWithOpen, setCarouselDataWithOpen] = useState({
        isOpen: false,
        image: null,
        rootData: null,
    })

    const getImageData = (clickedImageSource?: any, clickedRootData?: any) => {

        setCarouselDataWithOpen({
            isOpen: true,
            image: clickedImageSource,
            rootData: clickedRootData,
        })
    }

    const getPostGridPorps = (images: any, rootData: any) => {
        let heightNumber = [140, 140]

        if (images.length >= 5) {
            heightNumber = windowWidth > 640 ? [140, 140] : [100, 100]
        }
        else if (images.length === 1) {
            heightNumber = windowWidth > 640 ? [292] : [214]
        }
        else if (images.length === 2) {
            heightNumber = windowWidth > 640 ? [292] : [214]
        }
        else if (images.length === 3) {
            heightNumber = windowWidth > 640 ? [140, 140] : [100, 105]
        }
        else if (images.length === 4) {
            heightNumber = windowWidth > 640 ? [140, 140] : [100, 100]
        }

        return {
            itemsLength: images.length,
            getDataByOnClick: getImageData,
            rootData: rootData,
            gapX: 12,
            gapY: 12,
            radius: 10,
            heights: heightNumber,
            images: images,
        };
    }


    const handleFeaturColleLoveClick = (id: number) => {
        const prevCollectionData = [...featuredCollectionData]
        const findClickedData = prevCollectionData.find(data => data.id === id);

        if (findClickedData?.isMyLoved) {
            findClickedData.loves = findClickedData.loves - 1;
            findClickedData!.isMyLoved = false;
            setFeaturedCollectionData(prevCollectionData)
        } else {
            findClickedData!.loves = findClickedData!.loves + 1;
            findClickedData!.isMyLoved = true;
            setFeaturedCollectionData(prevCollectionData)
        }
    }



    return (
        <div className="discover_main_box">
            {carouselDataWithOpen.isOpen &&
                <PreviewCarousel
                    setCarouselDataWithOpen={setCarouselDataWithOpen}
                    image={carouselDataWithOpen.image}
                    rootData={carouselDataWithOpen.rootData} />
            }


            {/* ----------------------------Top Section---------------------------- */}
            <div className="discover_top_section flex items-center">
                <div className="text-left w-full mx-auto discover_max_w_box xs:px-4 sm:px-0 ">
                    <h4 className="xs:text-2xl sm:text-3xl md:text-4xl text-white">Discover, collect, and sell <br className="xs:hidden sm:block" /> extraordinary NFTs</h4>
                    <p className="xs:text-xs sm:text-sm md:text-base text-white mt-2">UNC is the world's first socially connected  NFT marketplace</p>

                    <div className="top_categories_box relative mt-8">
                        <div className="flex justify-between items-center ">
                            <p className="xs:text-xs sm:text-base text-white">Categories</p>
                            <div id="paginationDiv">

                            </div>
                        </div>


                        <Swiper
                            slidesPerView={1}
                            spaceBetween={10}
                            pagination={{
                                clickable: true,
                            }}
                            breakpoints={{
                                0: { slidesPerView: 1, spaceBetween: 10, },
                                350: { slidesPerView: 2, spaceBetween: 10, },
                                470: { slidesPerView: 3, spaceBetween: 15, },
                                640: { slidesPerView: 3, spaceBetween: 15, },
                                769: { slidesPerView: 4, spaceBetween: 10, },
                                1024: { slidesPerView: 5, spaceBetween: 10, },
                                1280: { slidesPerView: 6, spaceBetween: 20, },
                                1536: { slidesPerView: 7, spaceBetween: 20, },
                            }}
                            effect="fade"
                            modules={[Pagination]}
                            className="mySwiper mt-3 overflow-visible"
                        >
                            {disoverCatagoriesData.map((data, index) =>
                                <SwiperSlide key={data.id} style={{ overflow: 'visible' }}>
                                    <button className="rounded-md w-full overflow-hidden" onClick={() => handleCategorySelecte(index, data.name)} >
                                        <div className="relative flex justify-center items-center w-full h-[89px] xl:h-[96px]">
                                            <div
                                                style={{ background: data.color, opacity: 0.8, zIndex: -1 }}
                                                className="w-full h-full absolute top-0 left-0"> </div>

                                            <div className="flex flex-col justify-center items-center">
                                                <div>
                                                    <img src={data.photo} alt="" className="w-[35px] xl:w-[40px]" />
                                                </div>

                                                <h5 className="xs:text-xs md:text-sm 2xl:text-base text-white mt-2">{data.name}</h5>
                                            </div>
                                        </div>
                                    </button>
                                </SwiperSlide>
                            )}
                        </Swiper>
                    </div>
                </div>
            </div>



            <div className="discover_max_w_box mx-auto xs:px-4 sm:px-0 ">

                <div className="flex flex-wrap mb-10 mt-8">
                    <AnimatePresence>
                        {selectedCategories.map((cate, index) =>
                            <motion.div
                                initial="hidden"
                                animate="visible"
                                variants={{
                                    hidden: { opacity: 0 },
                                    visible: { opacity: 1 },
                                }}
                                whileHover={{ scale: 1.1 }}
                                transition={{ duration: 0.2 }}
                                className="flex justify-center items-center gradientBG rounded-full py-1 px-2 sm:py-2 sm:px-3.5 mr-3 mb-2.5" key={cate}>

                                <p className="text-white font-semibold whitespace-nowrap text-xxs xsm:text-xs sm:text-sm select-none">{cate}</p>

                                <button className="ml-2" onClick={() => hanldeCategoryDelete(cate)}>
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 sm:h-5 sm:w-5" fill="none" viewBox="0 0 24 24" stroke="#fff" strokeWidth={2}>
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </button>
                            </motion.div>
                        )}
                    </AnimatePresence>
                </div>

                <DiscoverLiveAuctions />
                <DiscoverBuyNFTs />
                <DiscoverMintNFTs />


                {/* ----------------------------Featured Collections---------------------------- */}
                <div className="mt-14 swiper_pagination_controller_box relative">
                    <div className="flex justify-between items-center">
                        <div className="relative inline-block">
                            <h1 className="text-sm xxsm:text-xl sm:text-2xl xl:text-3xl mr-3 font-extrabold text-cusBlack dark:text-white">Featured Collections</h1>
                            <div className="bottom-1 absolute -right-4">
                                <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width={12} height={12} viewBox="0 0 12 12">
                                    <defs>
                                        <linearGradient id="linear-gradient" x1="0.875" y1="0.174" x2="0.139" y2="0.84" gradientUnits="objectBoundingBox">
                                            <stop offset={0} stopColor="#00dbff" />
                                            <stop offset="0.529" stopColor="#e315e8" />
                                            <stop offset={1} stopColor="#ffd817" />
                                        </linearGradient>
                                    </defs>
                                    <circle id="Ellipse_1" data-name="Ellipse 1" cx={6} cy={6} r={6} fill="url(#linear-gradient)" />
                                </svg>
                            </div>
                        </div>
                    </div>

                    <Swiper
                        slidesPerView={1}
                        spaceBetween={10}
                        pagination={{
                            clickable: true,
                        }}
                        breakpoints={{
                            0: { slidesPerView: 1, spaceBetween: 40, },
                            769: { slidesPerView: 2, spaceBetween: 15, },
                            1024: { slidesPerView: 2, spaceBetween: 15, },
                            1280: { slidesPerView: 3, spaceBetween: 15, },
                            1536: { slidesPerView: 3, spaceBetween: 15, },
                        }}
                        effect="fade"
                        modules={[Pagination]}
                        className="mt-3 overflow-visible"
                    >
                        {featuredCollectionData.length > 0 &&
                            featuredCollectionData.map((collection, index) =>
                                <SwiperSlide key={collection.id}>
                                    <div className="xs:p-3 sm:p-5 mt-5 rounded-xl lightBlueBg">
                                        <div className="photo_grid_box">
                                            <PostGrid propObject={getPostGridPorps(collection.thumbs, collection.thumbs)} />
                                        </div>

                                        <div className="flex justify-between items-center xs:mt-4 md:mt-6 2xl:mt-4">
                                            <div className="flex justify-start items-center">
                                                <div className="xs:h-10 xs:w-10 sm:h-16 sm:w-16 md:w-10 md:h-8 lg:h-10 2xl:h-16 2xl:w-16 rounded-full relative ">
                                                    <img src={collection.profilePhoto} alt="" className="w-full h-full" />
                                                    <div className="absolute -bottom-2 -right-2">
                                                        <svg xmlns="http://www.w3.org/2000/svg" className="xs:w-7 sm:w-8 md:w-6 lg:w-7 2xl:w-auto" xmlnsXlink="http://www.w3.org/1999/xlink" width="34.249" height="35.201" viewBox="0 0 34.249 35.201">
                                                            <defs>
                                                                <filter id="Path_737" x={0} y={0} width="34.249" height="35.201" filterUnits="userSpaceOnUse">
                                                                    <feGaussianBlur stdDeviation={3} result="blur" />
                                                                    <feFlood floodColor="#f08" floodOpacity="0.314" />
                                                                    <feComposite operator="in" in2="blur" />
                                                                    <feComposite in="SourceGraphic" />
                                                                </filter>
                                                            </defs>
                                                            <g id="Group_1298" data-name="Group 1298" transform="translate(-1880.164 -1579.313)">
                                                                <g transform="matrix(1, 0, 0, 1, 1880.16, 1579.31)" filter="url(#Path_737)">
                                                                    <path id="Path_737-2" data-name="Path 737" d="M631.683,279.559s7.027-1.882,13.6,0a35.8,35.8,0,0,1-.061,14.375,29.879,29.879,0,0,1-13.568.032S629.949,286.243,631.683,279.559Z" transform="translate(-621.31 -272.12)" fill="#ff0091" stroke="#e90185" strokeMiterlimit={10} strokeWidth={1} />
                                                                </g>
                                                                <image id="Image_44" data-name="Image 44" width="10.02" height="10.02" transform="translate(1892.224 1588.373)" xlinkHref="data:image/png;base64,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" />
                                                            </g>
                                                        </svg>
                                                    </div>
                                                </div>

                                                <div className="ml-4 text-left">
                                                    <h4 className="xs:text-sm sm:text-xl md:text-xs lg:text-sm xl:text-xs 2xl:text-xl font-semibold text-cusBlack dark:text-white">{collection.profileName}</h4>
                                                    <p className="text-cusBlack dark:text-cusGray xs:text-xs sm:text-sm xl:text-xs 2xl:text-sm mt-1">Created by
                                                        <span className="text-black dark:text-white dark:font-normal font-extrabold xs:text-xs ml-1 sm:text-sm md:text-xs 2xl:text-sm">{collection.owner}</span></p>
                                                </div>
                                            </div>

                                            <button
                                                onClick={() => handleFeaturColleLoveClick(collection.id)}
                                                className="collections_slide_loves dark:bg-cusBlack bg-gray-200 flex justify-between xs:px-2 sm:px-4 xs:py-1 sm:py-2 items-center rounded-full">
                                                <p className="text-cusBlack dark:text-cusBlueWhite text-xs mr-2">{collection.loves}</p>

                                                {collection.isMyLoved
                                                    ? <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="#ff0091" stroke="#ff0091">
                                                        <path fillRule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clipRule="evenodd" strokeWidth={2} />
                                                    </svg>
                                                    : <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="none" stroke="#ff0091">
                                                        <path fillRule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clipRule="evenodd" strokeWidth={2} />
                                                    </svg>
                                                }

                                            </button>
                                        </div>

                                    </div>
                                </SwiperSlide>
                            )}
                    </Swiper>
                </div>
                <svg xmlns="http://www.w3.org/2000/svg" className="w-5 blackWhiteSVG" width="13.066" height="10.875" viewBox="0 0 13.066 10.875">
                    <path id="Path_945" data-name="Path 945" d="M616.016,112.407a3.65,3.65,0,0,0-5.154,0l-.33.33-.33-.33a3.649,3.649,0,0,0-5.153,0,3.686,3.686,0,0,0-.021,5.132c1.258,1.4,4.97,4.42,5.127,4.548a.577.577,0,0,0,.364.129h.013a.557.557,0,0,0,.376-.129c.158-.128,3.87-3.15,5.128-4.549A3.685,3.685,0,0,0,616.016,112.407Zm-.837,4.361a61.665,61.665,0,0,1-4.646,4.135,61.325,61.325,0,0,1-4.647-4.135,2.546,2.546,0,0,1-.02-3.544,2.492,2.492,0,0,1,3.521,0l.725.725a.562.562,0,0,0,.31.156.58.58,0,0,0,.531-.156l.726-.725a2.492,2.492,0,0,1,3.521,0A2.547,2.547,0,0,1,615.179,116.768Z" transform="translate(-604 -111.342)" fill="#ff0091" />
                </svg>


                <div className="mt-14 mb-8 grid xs:grid-cols-1 2xl:grid-cols-2 gap-x-5 gap-y-5 top_collections_box">
                    <div className="">
                        <div className="flex justify-between items-center">
                            <div className="flex justify-start items-center">
                                <h1 className="text-base xxsm:text-xl sm:text-2xl xl:text-3xl mr-3 font-extrabold text-cusBlack dark:text-white">Top collections in</h1>

                                <div ref={topColleInDropRef} className="cursor-pointer relative w-full text-left flex-1 max-w-[250px]"
                                    onClick={() => setTopColleInDropOpen(!topColleInDropOpen)}>

                                    <div className="flex justify-between items-center break-all">
                                        <h4 className="text-[#6F6DAB] font-bold text-sm xxsm:text-lg sm:text-2xl xl:text-3xl mr-3 ">{topColleInDropText}</h4>
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg"
                                                className={`h-4 w-4 transition-all ${topColleInDropOpen && 'rotate-180'}`}
                                                fill="none" viewBox="0 0 24 24" stroke="#6F6DAB" strokeWidth={5}>
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                                            </svg>
                                        </div>
                                    </div>

                                    <AnimatePresence>
                                        {topColleInDropOpen &&
                                            <motion.div
                                                animate={topColleInDropOpen ? "open" : "closed"}
                                                initial={{ y: -15, }}
                                                variants={{
                                                    open: { y: 0, },
                                                    closed: { y: -100, },
                                                }}
                                                exit={{ opacity: 0, y: -15 }}
                                                transition={{ duration: 0.2 }}
                                                className="rounded-xl overflow-hidden absolute top-9 xl:top-11 bg-white dark:bg-[#292757] shadow-lg
                                                        dark:shadow-[#00000060] border border-[#e6e8ec] dark:border-[#e6e8ec20] w-full left-0 z-20
                                                        min-w-[120px] sm:min-w-[150px]">

                                                {['1 Day', '2 Day', '3 Day', '4 Day',].map(item =>
                                                    <div onClick={() => { setTopColleInDropOpenText(item) }}
                                                        className={`py-3 px-4 hover:bg-[#e6e8ec] dark:hover:bg-cusBlack transition-all`} key={item}>
                                                        <p className="text-cusBlack dark:text-white text-xs lg:text-sm xl:text-base 
                                                        font-medium whitespace-nowrap overflow-hidden overflow-ellipsis">{item}</p>
                                                    </div>
                                                )}

                                            </motion.div>}
                                    </AnimatePresence>
                                </div>
                            </div>
                            <NavLink to="/explore" className="xs:text-xxs sm:text-base text-cusBlack dark:text-white">See all &gt;</NavLink>
                        </div>

                        <div className="mt-6 grid xs:grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-4">
                            {dicoverTopCollections.map((topColl, index) =>
                                <div className="top_collections_item p-4 rounded-xl flex justify-between items-center" key={topColl.id}>
                                    <div className="flex justify-start items-center">
                                        <p className="text-cusBlack dark:text-cusBlueWhite text-base">{index + 1}</p>
                                        <div className="w-14 h-14 rounded-full xs:ml-2 3xl:ml-3">
                                            <img src={topColl.logo} alt="" />
                                        </div>
                                        <div className="xs:ml-2 3xl:ml-4 text-left">
                                            <h4 className="text-base text-cusBlack font-semibold dark:font-normal dark:text-white">{topColl.name}</h4>
                                            <div className="flex justify-start items-center mt-2">
                                                <p className="text-cusBlack dark:text-cusBlueWhite text-xs">Floor Price</p>
                                                <div className="ml-5">
                                                    <svg className="w-[8px]" viewBox="0 0 256 417" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid">
                                                        <path className="fill-[#343434] dark:fill-[#FFFFFF60]" fill="" d="M127.961 0l-2.795 9.5v275.668l2.795 2.79 127.962-75.638z" />
                                                        <path className="fill-[#8C8C8C] dark:fill-[#FFFFFF]" fill="" d="M127.962 0L0 212.32l127.962 75.639V154.158z" />
                                                        <path className="fill-[#3C3C3B] dark:fill-[#FFFFFF60]" fill="" d="M127.961 312.187l-1.575 1.92v98.199l1.575 4.6L256 236.587z" />
                                                        <path className="fill-[#8C8C8C] dark:fill-[#FFFFFF]" fill="" d="M127.962 416.905v-104.72L0 236.585z" />
                                                        <path className="fill-[#141414] dark:fill-[#FFFFFF20]" fill="" d="M127.961 287.958l127.96-75.637-127.96-58.162z" />
                                                        <path className="fill-[#393939] dark:fill-[#FFFFFF60]" fill="" d="M0 212.32l127.96 75.638v-133.8z" />
                                                    </svg>

                                                </div>
                                                <p className="text-cusBlack dark:text-cusBlueWhite text-xs ml-2">{topColl.floorPrice}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="">
                                        <div className="px-4 py-1 rounded-md fle"
                                            style={topColl.rankRate ?
                                                topColl.rankRate < 0
                                                    ? { backgroundColor: 'var(--nagativeCollectionMark)', border: '1px solid #FF0000' }
                                                    : { backgroundColor: 'var(--positiveCollectionsMark)', border: '1px solid #21BF80' }
                                                : { backgroundColor: 'var(--nullCollectionsMark)', border: '1px solid #3C3980' }}>
                                            <p className="text-white text-xs">{topColl.rankRate ? topColl.rankRate + "%" : "--"}</p>
                                        </div>
                                        <div className="flex justify-end items-center mt-2">
                                            <svg className="w-[8px]" viewBox="0 0 256 417" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid">
                                                <path className="fill-[#343434] dark:fill-[#FFFFFF60]" fill="" d="M127.961 0l-2.795 9.5v275.668l2.795 2.79 127.962-75.638z" />
                                                <path className="fill-[#8C8C8C] dark:fill-[#FFFFFF]" fill="" d="M127.962 0L0 212.32l127.962 75.639V154.158z" />
                                                <path className="fill-[#3C3C3B] dark:fill-[#FFFFFF60]" fill="" d="M127.961 312.187l-1.575 1.92v98.199l1.575 4.6L256 236.587z" />
                                                <path className="fill-[#8C8C8C] dark:fill-[#FFFFFF]" fill="" d="M127.962 416.905v-104.72L0 236.585z" />
                                                <path className="fill-[#141414] dark:fill-[#FFFFFF20]" fill="" d="M127.961 287.958l127.96-75.637-127.96-58.162z" />
                                                <path className="fill-[#393939] dark:fill-[#FFFFFF60]" fill="" d="M0 212.32l127.96 75.638v-133.8z" />
                                            </svg>

                                            <p className="text-cusBlack dark:text-cusBlueWhite text-xs ml-2">{topColl.floorPrice2.toLocaleString()}</p>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>


                    <div className="xs:mt-3 2xl:mt-0">
                        <div className="flex justify-between items-center">
                            <div className="flex justify-start items-center">
                                <h1 className="xs:text-lg sm:text-2xl xl:text-3xl mr-2 font-extrabold text-cusBlack dark:text-white">Top</h1>

                                <div ref={topSellerDropRef} className="cursor-pointer relative w-full text-left grow max-w-[250px]"
                                    onClick={() => setTopSellerDropOpen(!topSellerDropOpen)}>

                                    <div className="flex justify-between items-center break-all">
                                        <h4 className="text-[#6F6DAB] font-bold text-sm xxsm:text-lg sm:text-2xl xl:text-3xl 
                                        mr-3 whitespace-nowrap overflow-ellipsis overflow-hidden">{topSellerDropText}</h4>
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg"
                                                className={`h-4 w-4 transition-all ${topSellerDropOpen && 'rotate-180'}`}
                                                fill="none" viewBox="0 0 24 24" stroke="#6F6DAB" strokeWidth={5}>
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                                            </svg>
                                        </div>
                                    </div>

                                    <AnimatePresence>
                                        {topSellerDropOpen &&
                                            <motion.div
                                                animate={topSellerDropOpen ? "open" : "closed"}
                                                initial={{ y: -15, }}
                                                variants={{
                                                    open: { y: 0, },
                                                    closed: { y: -100, },
                                                }}
                                                exit={{ opacity: 0, y: -15 }}
                                                transition={{ duration: 0.2 }}
                                                className="rounded-xl overflow-hidden absolute top-9 xl:top-11 bg-white dark:bg-[#292757] shadow-lg
                                                        dark:shadow-[#00000060] border border-[#e6e8ec] dark:border-[#e6e8ec20] w-full left-0 z-20
                                                        min-w-[120px] sm:min-w-[150px]">
                                                {['Seller', 'Buyer',].map(item =>
                                                    <div onClick={() => { settopSellerDropText(item) }}
                                                        className={`py-3 px-4 break-all hover:bg-[#e6e8ec] dark:hover:bg-cusBlack transition-all`} key={item}>
                                                        <p className="text-cusBlack dark:text-white text-xs lg:text-sm xl:text-base font-medium
                                                        whitespace-nowrap overflow-hidden overflow-ellipsis">{item}</p>
                                                    </div>
                                                )}
                                            </motion.div>}
                                    </AnimatePresence>
                                </div>


                                <h1 className="xs:text-lg grow-0 sm:text-2xl xl:text-3xl mr-2 ml-3 font-extrabold text-cusBlack dark:text-white">in</h1>


                                <div ref={topInDropRef} className="cursor-pointer relative w-full text-left grow max-w-[250px]"
                                    onClick={() => setTopInDropOpen(!topInDropOpen)}>

                                    <div className="flex justify-between items-center break-all">
                                        <h4 className="text-[#6F6DAB] font-bold text-sm xxsm:text-lg sm:text-2xl xl:text-3xl 
                                        mr-3 whitespace-nowrap overflow-ellipsis overflow-hidden">{topInDropText}</h4>
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg"
                                                className={`h-4 w-4 transition-all ${topInDropOpen && 'rotate-180'}`}
                                                fill="none" viewBox="0 0 24 24" stroke="#6F6DAB" strokeWidth={5}>
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                                            </svg>
                                        </div>
                                    </div>

                                    <AnimatePresence>
                                        {topInDropOpen &&
                                            <motion.div
                                                animate={topInDropOpen ? "open" : "closed"}
                                                initial={{ y: -15, }}
                                                variants={{
                                                    open: { y: 0, },
                                                    closed: { y: -100, },
                                                }}
                                                exit={{ opacity: 0, y: -15 }}
                                                transition={{ duration: 0.2 }}
                                                className="rounded-xl overflow-hidden absolute top-9 xl:top-11 bg-white dark:bg-[#292757] shadow-lg
                                                        dark:shadow-[#00000060] border border-[#e6e8ec] dark:border-[#e6e8ec20] w-full left-0 z-20
                                                        min-w-[120px] sm:min-w-[150px]">
                                                {['1 Day', '2 Day', '3 Day', '4 Day',].map(item =>
                                                    <div onClick={() => { setTopInDropText(item) }}
                                                        className={`py-3 px-4 break-all hover:bg-[#e6e8ec] dark:hover:bg-cusBlack transition-all`} key={item}>
                                                        <p className="text-cusBlack dark:text-white text-xs lg:text-sm xl:text-base font-medium
                                                        whitespace-nowrap overflow-hidden overflow-ellipsis">{item}</p>
                                                    </div>
                                                )}
                                            </motion.div>}
                                    </AnimatePresence>
                                </div>

                            </div>
                            <NavLink to="/explore" className="xs:text-xxs sm:text-base text-cusBlack dark:text-white">See all &gt;</NavLink>
                        </div>

                        <div className="mt-6 grid xs:grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-4">
                            {dicoverTopSallerInDayData.map((data, index) =>
                                <div className="top_collections_item p-4 rounded-xl flex justify-between items-center" key={data.id}>
                                    <div className="flex justify-start items-center w-full h-full ">
                                        <p className="text-cusBlack dark:text-cusBlueWhite text-base">{index + 1}</p>
                                        <div>
                                            <div className="w-14 h-14 rounded-full xs:ml-2 3xl:ml-3">
                                                <img src={data.logo} alt="" />
                                            </div>
                                        </div>
                                        <div className="xs:ml-3 3xl:ml-4 text-left w-full h-full overflow-hidden">
                                            <h4 className="text-sm text-cusBlack font-semibold dark:font-normal dark:text-white w-full whitespace-nowrap truncate">{data.userName}</h4>
                                            <div className="flex justify-start items-center mt-2">
                                                <p className="text-cusBlack dark:text-cusBlueWhite text-xs ">${data.price.toLocaleString()}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>




                <HotAndExpoloreSection />




                <DiscoverExploreSection />


            </div>
        </div >
    );
}

